"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class PersonService {
    /**
     * @returns Profile The profile for the logged in user
     * @throws ApiError
     */
    static showProfile() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/profile',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Profile The updated profile
     * @throws ApiError
     */
    static updateProfile(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param personIdOrUuid
     * @returns ContactInfo List of contact infos for the given person
     * @throws ApiError
     */
    static getContactInfos(personIdOrUuid) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/people/{personIdOrUuid}/contact_infos',
            path: {
                'personIdOrUuid': personIdOrUuid,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param personIdOrUuid
     * @param requestBody
     * @param combinedFields
     * @returns ContactInfo The new contact info for the given person
     * @throws ApiError
     */
    static createContactInfo(personIdOrUuid, requestBody, combinedFields) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/people/{personIdOrUuid}/contact_infos',
            path: {
                'personIdOrUuid': personIdOrUuid,
            },
            query: {
                'combinedFields': combinedFields,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param personIdOrUuid
     * @param requestBody
     * @param combinedFields
     * @returns ContactInfo The updated contact info for the given person
     * @throws ApiError
     */
    static updateContactInfo(personIdOrUuid, requestBody, combinedFields) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/people/{personIdOrUuid}/contact_infos',
            path: {
                'personIdOrUuid': personIdOrUuid,
            },
            query: {
                'combinedFields': combinedFields,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param personIdOrUuid
     * @param requestBody
     * @returns Person The updated person
     * @throws ApiError
     */
    static updatePerson(personIdOrUuid, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/people/{personIdOrUuid}',
            path: {
                'personIdOrUuid': personIdOrUuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.PersonService = PersonService;
